import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'image_list'

export const dataPointDefinition = {
  retracedId: 'image_list',
  name: 'Image List',
  meta: {},
  fieldTypeId: 'MULTIPLE_PHOTO_UPLOAD',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 290,
  sectionId: '1.1',
  impactArea: 'About',
  impactAreaId: 'ABOUT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
